import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as variableOverrides from '../../../../../variable-overrides'
import type * as aliases from '../../../../aliases'
import type * as currentRendering from '../../feature'
import type * as widgets from '../widgets'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** TODO: Explain what is this */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(
    currentRenderingFeature: currentRendering.Feature,
    widgetFeature: widgets.Feature,
    variablesFeature: variableOverrides.Feature,
    aliasesFeature: aliases.Feature,
  ) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Slideout',
      parent: currentRenderingFeature,
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.triggerSlideoutWidgetRendering(
        currentRenderingFeature,
        widgetFeature,
        variablesFeature,
        aliasesFeature,
      ),
    )
  }
}
